/* shortcodes */
import '../../shortcodes/arrow-button/index';

import './with-case-studies-footer.pcss';
import './with-case-studies-footer';